import React from 'react';

//stateless component: hence use function rather than ES6 class
export default function({label, value}) {
  return (
    <p><strong>{label}</strong>: {value}</p>
  );
}
